export var NAME = 'abstract';
export var ABSTRACT_ARCHIVED = "".concat(NAME, "/ABSTRACT_ARCHIVED");
export var ABSTRACT_SEARCH_COMPLETED = "".concat(NAME, "/ABSTRACT_SEARCH_COMPLETED");
export var ABSTRACT_SEARCH_REQUESTED = "".concat(NAME, "/ABSTRACT_SEARCH_REQUESTED");
export var ABSTRACTS_UPDATED = "".concat(NAME, "/ABSTRACTS_UPDATED");
export var ABSTRACT_VIEW_REQUESTED = "".concat(NAME, "/ABSTRACT_VIEW_REQUESTED");
export var ABSTRACT_VIEW_COMPLETED = "".concat(NAME, "/ABSTRACT_VIEW_COMPLETED");
export var ABSTRACT_VIEW_FAILED = "".concat(NAME, "/ABSTRACT_VIEW_FAILED");
export var NUMBER_OF_SECONDS_BETWEEN_UPDATES = 30;
export var STATUS_PROCESSING = 'processing';
export var STATUS_COMPLETED = 'completed';
export var STATUS_FAILED = 'failed';
export var STATUSES = {
  STATUS_PROCESSING: STATUS_PROCESSING,
  STATUS_COMPLETED: STATUS_COMPLETED,
  STATUS_FAILED: STATUS_FAILED
};